import { useSelector } from 'react-redux'
import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { Element } from '../../../../common/html/element'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { selectCompanyAlertsById } from '../../store/slice'
import { COLUMN_IDS } from './helper'
import { Portfolio } from './Portfolio'
import { TypeDescription } from './TypeDescription'

export const TableCell = ({ data, colId, rowId, rowIndex }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const readStatus = useSelector(selectCompanyAlertsById(rowId, 'readStatus'))

  const renderCell = () => {
    switch (colId) {
      case COLUMN_IDS.STT:
        return rowIndex + 1
      case COLUMN_IDS.TYPE_DESCRIPTION:
        return <TypeDescription rowId={rowId} />
      case COLUMN_IDS.DATE:
        return (
          <Element className="whiteSpaceNowrap">
            {formatDateTime(data, FORMAT.DATE, locale, timezone)}
          </Element>
        )
      case COLUMN_IDS.PORTFOLIO:
        return <Portfolio rowId={rowId} data={data} />
      default:
        return data
    }
  }

  return (
    <Element className={readStatus ? 'fw400' : 'fw600'}>{renderCell()}</Element>
  )
}
